import type { ReviewerResponse } from '../schemas/sessionReviewers'

const HOUR = 3_600_000
const DAY = 24 * HOUR
export const GROUPS = { week: { step: 7 * DAY, buckets: 12 }, day: { step: DAY, buckets: 30 }, hour: { step: HOUR, buckets: 48 } }
export type Group = keyof typeof GROUPS

export function observationBucket(time: number, group: Group): number {
  const date = new Date(time)
  if (group === 'hour') return Math.floor(time / HOUR) * HOUR
  date.setUTCHours(0, 0, 0, 0)
  if (group === 'week') date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 6) % 7)
  return date.getTime()
}

export function observationChartData(series: ReviewerResponse['series'], group: Group, code: string, now: number) {
  const { step, buckets } = GROUPS[group]
  const end = observationBucket(now, group)
  const start = end - (buckets - 1) * step
  const counts = new Map<string, number>()
  const points = Array.from({ length: buckets }, (_, index) => ({ time: start + index * step, count: 0 }))
  for (const item of series) {
    const timestamp = Date.parse(item.time)
    if (timestamp > now) continue
    const time = observationBucket(timestamp, group)
    const point = points[(time - start) / step]
    if (!point) continue
    counts.set(item.code, (counts.get(item.code) ?? 0) + item.count)
    if (!code || code === item.code) point.count += item.count
  }
  return { points, options: [...counts].sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0])), total: [...counts.values()].reduce((a, b) => a + b, 0) }
}


export function observationPeriod(time: number, group: Group) {
  const start = observationBucket(time, group)
  return { from: new Date(start).toISOString(), to: new Date(start + GROUPS[group].step).toISOString() }
}
